<template>
  <div id="artical_container">
    <div class="nav-header">
      <van-nav-bar :title="infoObj.title" left-arrow @click-left="leftFn" />
    </div>
    <div class="list">
      <artical-list :articalObj="infoObj" />
    </div>
  </div>
</template>

<script>
import ArticalList from "@/components/parent-course/artical-list.vue";
import { verticalScreen } from "@/assets/js/vertical-screen";
import { _addIntegral, _checkUserWatch, _detail } from "@/api/parent-course";
import { _recordTimes } from "@/api/growth";
import { Toast } from "vant";
import { decryptBy } from "@/assets/js/encryption";
export default {
  name: "artical",
  components: { ArticalList },
  props: {},
  data() {
    return {
      // 记录时间
      recordParams: {
        contentId: "",
        day: "",
        seconds: "",
        userId: "",
      },
      watchTime: 0, //观看时间
      timerInterval: "",
      infoObj: {}, //文章信息列表
      timeFiveFlag: false, //是否大于5s
      okFlag: false, //是否满足大于5s和文章滑到底部
      Timer: "",
      articalReadedFlag: true, // true代表没有阅读，false代表已读
      // 积分的参数
      integParams: {
        businessId: "", //文章视频id
        name: "", //文章视频名称
        type: "", //2文章 3视频
      },
      alreadSend: false, //是否发送成功
      TimerSetTime: "",
      // 查询用户是否观看过此视频
      readParams: {
        businessId: "", //视频或者文章的id
        // userId:'',//用户id
      },
      courseId: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 返回
    leftFn() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("/");
      } else {
        this.$router.back();
      }
    },
    timeFn() {
      this.TimerSetTime = setTimeout(() => {
        this.timeFiveFlag = true;
      }, 5000);
    },
    initHeight() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop; //滚动条Y轴上的滚动距离
      let scrollHeight = document.documentElement.scrollHeight; //文档的总高度
      let windowHeight = document.body.clientHeight; //浏览器视口的高度
      //文章的高度大于视口，可以滑动
      if (scrollTop + windowHeight >= scrollHeight && this.timeFiveFlag) {
        //到底部了
        this.okFlag = true;
        // 发送积分请求
        if (this.okFlag) {
          // 发送一次积分后，就不能允许再次发送积分请求
          // this.articalReadedFlag && this.addIntegral(this.integParams)
        }
      }
      // 文章的高度小于视口
      if (scrollHeight < windowHeight && this.timeFiveFlag) {
        this.okFlag = true;
        if (this.okFlag) {
          // 发送一次积分后，就不能允许再次发送积分请求
          // this.articalReadedFlag && this.addIntegral(this.integParams)
        }
        //发送积分请求
      }
    },
    // 用户获取积分
    async addIntegral(integParams) {
      try {
        let res = await _addIntegral(integParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          this.alreadSend = true; //已经发送
        } else {
          this.alreadSend = false; //没有发送或者发送失败
          Toast(message);
        }
      } catch (error) {}
    },
    // 查询用户是否观看过此文章
    async checkUserWatch(readParams) {
      try {
        let res = await _checkUserWatch(readParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data) return (this.articalReadedFlag = true); //data返回为true，没有阅读过
          this.articalReadedFlag = false;
        } else {
          this.articalReadedFlag = false;
          Toast(message);
        }
      } catch (error) {}
    },
    // 记录次数
    async recordTimes(recordParams) {
      try {
        let res = await _recordTimes(recordParams);
      } catch (error) {}
    },

    async detail(id, courseId) {
      if (courseId == "") {
        var res = await _detail({ id });
      } else {
        var res = await _detail({ id, courseId });
      }
      console.log(res);
      if (res.code == 200) {
        return res.data;
      }
    },
  },
  beforeCreate() {},
  async created() {
    let info = JSON.parse(localStorage.getItem("videoInfo"));
    if (localStorage.getItem("isCourse")) {
      this.courseId = localStorage.getItem("isCourse");
    } else {
      this.courseId = "";
    }
    info = await this.detail(info.id, this.courseId);
    this.recordParams.contentId = info.id;
    this.readParams.businessId = info.id;
    // 检查文章是否被阅读过并且获得过积分
    // this.checkUserWatch(this.readParams)
    // 获取用户的id
    let infoDeatil = JSON.parse(decryptBy(localStorage.getItem("userInfo")));
    // this.readParams.userId = infoDeatil.id
    this.recordParams.userId = infoDeatil.userId;
    let yearNow = new Date().getFullYear();
    let monthNow = new Date().getMonth() + 1;
    let dayNow = new Date().getDate();
    if (+monthNow < 10) monthNow = "0" + monthNow;
    if (+dayNow < 10) dayNow = "0" + dayNow;
    let allDaty = yearNow + "-" + monthNow + "-" + dayNow;
    this.recordParams.day = allDaty;
    this.infoObj = info;
    this.integParams.businessId = info.id;
    this.integParams.name = info.title;
    this.integParams.type = 2; //文章
  },
  beforeMount() {},
  mounted() {
    verticalScreen();
    this.timeFn();
    window.addEventListener("scroll", this.initHeight);
    // 当文章高度小于视口高度，无法触发滚动事件，轮询判断
    this.Timer = setInterval(() => {
      this.initHeight();
      if (this.okFlag) clearInterval(this.Timer);
    }, 500);
    this.timerInterval = setInterval(() => {
      this.watchTime = this.watchTime + 1;
    }, 1000);
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {
    if (this.Timer) clearInterval(this.Timer);
    if (this.TimerSetTime) clearTimeout(this.TimerSetTime);
    window.removeEventListener("scroll", this.initHeight, false);
    // 将统计的时间发送给后台,记录次数以及时间
    this.recordParams.seconds = this.watchTime;
    this.recordTimes(this.recordParams);
    clearInterval(this.timerInterval);
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
#artical_container {
  min-height: 100%;
  background-color: #f5f7fa;
  overflow: hidden;
  padding-bottom: 75px;
  .list {
    margin-top: 46px;
  }
  .nav-header {
    .van-nav-bar {
      position: fixed;
      top: 0;
      width: 100%;
      ::v-deep .van-nav-bar__title {
        color: #161515;
        font-size: 18px;
        font-weight: 500;
      }
      ::v-deep .van-nav-bar__arrow {
        font-size: 18px;
      }
    }
  }
}
</style>
